module.exports = __webpack_public_path__ + "img/type-4.7693f321.png";